export default __webpack_public_path__ + "654621b0d75ae0708c76f9f2c2fbace7.png";